module.exports = __webpack_public_path__ + "static/media/south-australian-ridge.90c8be69.jpeg";